import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';
import AdminLoginScreen from './components/admin/AdminLoginScreen';
import AdminDashboardLayout from './components/admin/AdminDashboardLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import UserManagement from './components/admin/UserManagement';
import SubscriptionManagement from './components/admin/SubscriptionManagement';
import CategoryManagement from './components/admin/CategoryManagement';
import AuditLogs from './components/admin/AuditLogs';
import DeletedUsersManagement from './components/admin/DeletedUsersManagement';
import PromoCodeManagement from './components/admin/PromoCodeManagement';
import AdminSettings from './components/admin/AdminSettings';
import LegalContentManagement from './components/admin/LegalContentManagement';
import {
  ContactsManagement,
  ConversationsManagement,
  BlocksManagement,
  FavoritesManagement,
  AlbumsManagement,
  TapsManagement,
  PresenceManagement,
  ProfileCardsManagement,
  ProfileImageViewsManagement,
} from './components/admin/AppDataManagement';
import TermsAndConditionsPage from './components/TermsAndConditionsPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import SafetyAndPrivacyPage from './components/SafetyAndPrivacyPage';
import SupportPage from './components/SupportPage';
import DeleteAccountPage from './components/DeleteAccountPage';
import './index.css';

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLoginScreen />} />
          <Route path="/admin" element={<AdminProtectedRoute><AdminDashboardLayout /></AdminProtectedRoute>}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="subscriptions" element={<SubscriptionManagement />} />
            <Route path="categories" element={<CategoryManagement />} />
            <Route path="promo-codes" element={<PromoCodeManagement />} />
            <Route path="deleted-users" element={<DeletedUsersManagement />} />
            <Route path="contacts" element={<ContactsManagement />} />
            <Route path="conversations" element={<ConversationsManagement />} />
            <Route path="blocks" element={<BlocksManagement />} />
            <Route path="favorites" element={<FavoritesManagement />} />
            <Route path="albums" element={<AlbumsManagement />} />
            <Route path="taps" element={<TapsManagement />} />
            <Route path="presence" element={<PresenceManagement />} />
            <Route path="profile-cards" element={<ProfileCardsManagement />} />
            <Route path="profile-image-views" element={<ProfileImageViewsManagement />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="legal-content" element={<LegalContentManagement />} />
          </Route>

          {/* Public Pages */}
          <Route path="/terms" element={<TermsAndConditionsPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/safety-and-privacy" element={<SafetyAndPrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;
